import angular from 'angular'

const smartyModule = angular
    .module('app.smarty', [])

export default smartyModule.name
/**
 * model格式[{
                        "cityList": [
                            {
                                "sfdqDm": "440300",//省份地区代码
                                "sfdqmc": "长沙市",//省份地区名称

                            }
                        ],
                        "sfdqDm": "440000",
                        "sfdqmc": "湖南",
                    }]

    callback 传入选择城市后的操作 返回选择的城市对象
*/
smartyModule.component('smartySelect', {
    template: `<div class="clearfix fl">
    <select ng-model="$ctrl.select1" ng-options="item.sfdqmc for item in $ctrl.model" ng-change="$ctrl.getProvince()" class="smartySelect"></select>
                <select ng-model="$ctrl.select2" ng-options="data.sfdqmc for data in $ctrl.select1['cityList']" ng-change="$ctrl.getCity()" class="smartySelect"></select>
    </div>`,
    bindings: {
        model: '=',
        callback: '&',
    },
    controller: [function () {
        this.getProvince = function () {
        }
        this.getCity = function () {
            this.callback({ arg: this })
        }
    }],
})



// WEBPACK FOOTER //
// ./src/components/smarty/index.js